import { CONTACT } from './contact.js';

/**
 * Hero text + CTAs per route. Background image stays the same everywhere.
 * Action: `{ to, label, variant }` for React Router, or `{ href, label, variant, external? }` for tel / links.
 */
const home = {
  ariaLabel: 'ProScape landscaping and lawn care',
  eyebrow: 'Landscaping & lawn care',
  title: 'ProScape Outdoor Services',
  lede:
    'Patios, retaining walls, walkways, mowing, beds, and cleanups—free quotes, and we’re booking services now.',
  actions: [
    { to: '/contact', label: 'Get a free quote', variant: 'primary' },
    { to: '/gallery', label: 'See our work', variant: 'ghost' },
  ],
};

const services = {
  ariaLabel: 'ProScape services — hardscape, design, mowing, and seasonal work',
  eyebrow: 'What we offer',
  title: 'Services built around your property',
  lede:
    'Hardscape—patios, retaining walls, and walkways—plus beds, mulch, striped mowing, and seasonal cleanups. Tell us what you need and we’ll quote it.',
  actions: [
    { to: '/contact', label: 'Book your free quote', variant: 'primary' },
    { to: '/gallery', label: 'See project photos', variant: 'ghost' },
  ],
};

const gallery = {
  ariaLabel: 'ProScape project gallery',
  eyebrow: 'Real jobs',
  title: 'Our work, on the ground',
  lede:
    'Before-and-after trimming, wall builds, lawn stripes, and branding shots—tap any photo on this page to view it larger.',
  actions: [
    { to: '/contact', label: 'Book a visit', variant: 'primary' },
    { to: '/services', label: 'Browse services', variant: 'ghost' },
  ],
};

const contact = {
  ariaLabel: 'Contact ProScape Outdoor Services',
  eyebrow: 'Corning & nearby',
  title: 'Book your free quote',
  lede: `Call ${CONTACT.phoneDisplay} for a fast estimate, or message on Facebook—we’re booking services now. ${CONTACT.serviceArea}.`,
  actions: [
    { href: `tel:${CONTACT.phoneTel}`, label: 'Call for your quote', variant: 'primary' },
    { href: CONTACT.facebookUrl, label: 'Message for a quote', variant: 'ghost', external: true },
  ],
};

const privacy = {
  ariaLabel: 'ProScape Outdoor Services privacy policy',
  eyebrow: 'Legal',
  title: 'Privacy Policy',
  lede:
    'What we collect when you visit this site or call for a quote, how we use it, and how to reach us about it.',
  actions: [
    { to: '/terms', label: 'Terms of Service', variant: 'ghost' },
    { to: '/contact', label: 'Contact us', variant: 'primary' },
  ],
};

const terms = {
  ariaLabel: 'ProScape Outdoor Services terms of service',
  eyebrow: 'Legal',
  title: 'Terms of Service',
  lede:
    'The rules for using this website—plus how quotes, estimates, and project photos should be read.',
  actions: [
    { to: '/privacy', label: 'Privacy Policy', variant: 'ghost' },
    { to: '/contact', label: 'Get a free quote', variant: 'primary' },
  ],
};

const BY_PATH = {
  '/': home,
  '/services': services,
  '/gallery': gallery,
  '/contact': contact,
  '/privacy': privacy,
  '/terms': terms,
};

export function getHeroContent(pathname) {
  return BY_PATH[pathname] ?? home;
}
